module.exports = __webpack_public_path__ + "static/media/reno-small.14f28508.webp";